import Notifications from "@/src/components/settings/notifications/notifications";
import { useMarkAllNotificationAsRead } from "@/src/services/api/notification/notification.hooks";
import { useTheme } from "@/src/styles/theme-provider";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ActivityIndicator,
  Pressable,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

const NotificationsComponent = Notifications as React.ComponentType<{
  isUnreadOnly: boolean;
}>;

const NOTIFICATION_TABS = ["LABEL_ALL", "LABEL_UNREAD"] as const;
type NotificationTab = (typeof NOTIFICATION_TABS)[number];

const NotificationScreen = () => {
  const { t } = useTranslation();
  const { varStyle } = useTheme();
  const [activeTab, setActiveTab] = useState<NotificationTab>(
    NOTIFICATION_TABS[0],
  );
  const { mutate: markAllAsRead, isPending: isMarkingAll } =
    useMarkAllNotificationAsRead();

  return (
    <View style={varStyle} className="flex-1 bg-obsidian gap-4">
      <ScrollView
        contentContainerClassName="gap-4"
        showsVerticalScrollIndicator={false}
      >
        {/* ── Header card ── */}
        <View className="bg-chalk px-4 pt-4 md:px-6 rounded-2xl md:rounded-[16px] md:border md:border-ash-3">
          <View className="flex-row items-center justify-between">
            <Text className="text-base font-bold text-onyx">
              {t("LABEL_NOTIFICATION")}
            </Text>
            <TouchableOpacity
              onPress={() => markAllAsRead()}
              disabled={isMarkingAll}
              className="px-4 py-1.5 rounded-full bg-ash md:border md:border-ash-3 hover:bg-ash-3"
            >
              {isMarkingAll ? (
                <ActivityIndicator size="small" />
              ) : (
                <Text className="text-xs text-primary font-medium">
                  {t("BTN_MARK_ALL_AS_READ")}
                </Text>
              )}
            </TouchableOpacity>
          </View>

          {/* Tab strip with padding below */}
          <View className="pt-3 pb-3">
            <View className="flex-row gap-1">
              {NOTIFICATION_TABS.map((tab) => {
                const isActive = activeTab === tab;
                return (
                  <Pressable
                    key={tab}
                    onPress={() => setActiveTab(tab)}
                    className={`px-4 py-2 rounded-t-xl ${isActive ? "bg-primary-2 border-b-2 border-primary hover:bg-primary-2" : "hover:bg-ash-3"}`}
                  >
                    <Text
                      className={`text-sm font-medium ${isActive ? "text-primary" : "text-ash-1"}`}
                    >
                      {t(tab)}
                    </Text>
                  </Pressable>
                );
              })}
            </View>
          </View>
        </View>

        {/* ── Content card ── */}
        <View className="flex-1 bg-chalk rounded-2xl md:rounded-[16px] px-2 py-2 md:p-4 md:border md:border-ash-3">
          <NotificationsComponent isUnreadOnly={activeTab === "LABEL_UNREAD"} />
        </View>
      </ScrollView>
    </View>
  );
};

export default NotificationScreen;
